export default __webpack_public_path__ + "static/media/dtomkins_resume_02-22.7d825816.pdf";